import { jsx as p } from "react/jsx-runtime";
import { clsx as n } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import e from "./roche-pipeline-lane-row.module.scss.js";
const a = ({
  laneCount: i,
  hasTightGap: o = !1,
  children: l
}) => /* @__PURE__ */ p(
  "div",
  {
    className: n(e["pipeline-lane-row"], o && e["pipeline-lane-row--tight-gap"]),
    style: { "--pipeline-lane-count": i },
    children: l
  }
);
export {
  a as RocheUIPipelineLaneRow
};
